export default __webpack_public_path__ + "static/media/del-content-icon.15be6d8a.svg";